<div id="special" class="mt-5">
    <div class="container-fluid px-2 px-lg-5">
        <div class="row">
            <div class="col-12" data-scroll>
                <h2 class="font-weight-bold text-center">Facilities</h2>
                <hr class=" p-1 mb-5" style="width: 160px;">
              
            </div>
        </div>
        <owl-carousel-o [options]="customOptions">

            <ng-container *ngFor="let data of facility; let i=index">
              <ng-template carouselSlide >
                <div class="card shadow-lg mx-auto" style="width: 18rem;">
                    <img appLazyload class="card-img-top" [src]="data.imgUrl" [alt]="data.title">
                    <div class="card-body">
                      <h5 class="card-title text-center">{{data.title}}</h5>
                      <p class="text-justify">{{data.description}}</p>
                      <a routerLink="{{data.link}}" class="btn btn-warning ">Know More</a>
                    </div>
                  </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
    </div>
</div>